import ScrollHint from './ScrollHint';

export default ScrollHint;
